import { getStaticPropsGenerator } from '@cinch-nx/landing-feature-policy-page'
import { traceFunction } from '@core/datadog-server'

const path = 'rangeclaim'

export const getStaticProps = traceFunction(
  'rangeclaim.getStaticProps',
  getStaticPropsGenerator(path),
)

export { PolicyPageFeature as default } from '@cinch-nx/landing-feature-policy-page'
